// src/lib/summaryView.ts
//
// «Media de la cadena» on Resumen: the server fills it only when the selection is part of one
// chain and not all of it (the same rate over the chain's hotels the user can see). With nothing
// to compare with every value is null and the column is left out instead of showing dashes.
import type { SummaryRow } from '@/types/analytics';

export const hasChainAverage = (rows: Pick<SummaryRow, 'chainAvgPct'>[] | undefined): boolean =>
  (rows ?? []).some((row) => row.chainAvgPct !== null && row.chainAvgPct !== undefined);
